import React, { useState } from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { renderList } from "common/vue/render-list";
import "./Select.scss";

function Select({
  options = [],
  placeholder = "Select an option",
  value = null,
  disabled = false,
  onChange = () => {},
  ...restProps
}) {
  const [visible, setVisible] = useState(false);

  function displayValue() {
    if (value) {
      return value.label;
    }
    return placeholder;
  }

  function labelPrefix() {
    return value?.prefix;
  }

  function disableOpen() {
    return disabled || options.length === 0;
  }

  function isCurrentValue({ value: itemValue }) {
    return itemValue === value?.value;
  }

  function toggle() {
    if (disableOpen()) {
      return;
    }
    setVisible(!visible);
  }

  function select(option) {
    onChange(option.value);
    toggle();
  }

  function handleFocusOut(event) {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setVisible(false);
    }
  }

  return (
    <div
      {...restProps}
      className="select scope-de2e26f7"
      tabIndex="0"
      onBlur={handleFocusOut}
      data-testid="select"
    >
      <div
        className={cn("select__selector scope-de2e26f7", disabled && "select__selector--disabled")}
        onClick={() => toggle()}
        data-testid="select-selector"
      >
        {labelPrefix() ? (
          <img
            className="select__prefix scope-de2e26f7"
            src={labelPrefix()}
            data-testid="select-prefix"
          />
        ) : null}
        <div
          className={cn("select__text scope-de2e26f7", !value && "select__text--placeholder")}
          data-testid="select-text"
        >
          {displayValue()}
        </div>
        <UseSvg
          className={cn("select__arrow scope-de2e26f7", visible && "select__arrow--expanded")}
          icon="arrow-right"
          data-testid="select-arrow"
        />
        <div
          className={cn("select__menu scope-de2e26f7", !visible && "hidden")}
          data-testid="select-menu"
        >
          <ul className="select__list scope-de2e26f7" data-testid="select-list">
            {renderList(options, item => (
              <li
                className={cn(
                  "select__list-item scope-de2e26f7",
                  isCurrentValue(item) && "select__list-item--current"
                )}
                key={item.value}
                onClick={e => {
                  e.stopPropagation();
                  select(item);
                }}
                data-testid="select-list-item"
              >
                {item.prefix ? (
                  <img
                    className="select__prefix scope-de2e26f7"
                    src={item.prefix}
                    data-testid="select-prefix-1"
                  />
                ) : null}
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Select;
